import errorUtils from "~/utils/errorUtils";
import printerNotifier from "~/utils/printerNotifier";
import slsApi from "~/request/slsApi";
import uuid from "~/utils/uuid";
import WarehouseApi from "~/request/warehouseApi";

const port = 12705
const url = `ws://127.0.0.1:${port}`
let connected = false
let socket = null

let version = null
const commandCallback = {}

const onMessage = (event) => {
    let response = JSON.parse(event.data || '{}')
    console.log('视频号socket回调', response)
    //拿到打印结果的回调
    if (response.command === 'print') {
        console.log('视频号打印结果的回调', response)
        try {
            const {results = []} = response
            results.forEach(result => {
                const docRes = printResultMapper(result)
                printerNotifier.setNotifierResponse(docRes.documentID, docRes)
                printerNotifier.notifyListeners(docRes.documentID)
            })
            const uploadResult = {
                taskID: response.requestID,
                printStatus: results.map(printResultMapper)
            }
            uploadResult.deviceMonitorId = WarehouseApi.getDeviceMonitorId()
            slsApi.logPrinterResultList([uploadResult]).then(() => {
                console.log('打印日志记录成功！')
            }).catch(err => {
                throw err
            })
        } catch (e) {
            errorUtils.uploadError('上传打印日志动作异常', e.message).then(() => console.log('上传打印日志动作异常成功', e)).catch(err => {
                console.error('上传打印日志动作异常失败', e, err)
            })
        }
    } else if (response.command === 'getAppInfo') {
        console.log('视频号打印组件版本加载成功', response.appInfo)
        version = response.appInfo.version
    }
    if (commandCallback['f' + response.requestID]) {
        commandCallback['f' + response.requestID](response)
    }
}

//支持
function doConnect() {
    socket = new WebSocket(url)
    socket.onopen = function (event) {
        console.log('视频号打印组件连接成功')
        connected = true
        // 监听消息
        socket.onmessage = onMessage
        // 监听Socket的关闭
        socket.onclose = function (event) {
            connected = false
            console.log('视频号打印组件连接关闭', event)
            //如果断开连接，自动1s后重新连接
            setTimeout(() => {
                doConnect()
            }, 1000)
        }

        // 获取版本号
        getAppInfo()
    }

    socket.onerror = (error) => {
        console.error(`视频号打印组件发生错误`, error)
    }
}


// 获取打印机列表(getPrinters)
const getPrinters = () => {
    const request = getRequestObject({
        command: 'getPrinterList'
    })
    return new Promise(((resolve, reject) => {
        sendCommand(request).then(result => {
            resolve({
                ... result,
                printers: result.printerList
            })
        }).catch(reject)
    }))
}

const getAppInfo = () => {
    const request = getRequestObject({
        command: 'getAppInfo'
    })
    return sendCommand(request)
}

// 发送打印/预览数据协议(print)
const print = (options) => {
    let request = getRequestObject({
        command: 'print',
        version
    })
    request = {
        ...request,
        ...options
    }
    return sendCommand(request)
}

const getConnect = () => {
    return connected
}

const getRequestObject = ({command, version}) => {
    let request = {}
    request.requestID = uuid.getUUID(8, 16)
    request.command = command
    version && (request.version = version)
    return request
}

const sendCommand = request => {
    if (getConnect()) {
        return new Promise(resolve => {
            socket.send(JSON.stringify(request))
            commandCallback['f' + request.requestID] = (response) => {
                resolve(response)
                commandCallback['f' + request.requestID] = null
            }
        })
    } else {
        return Promise.reject({
            message: '视频号打印组件连接已断开！'
        })
    }
}

function printResultMapper(result) {
    const {taskID, success, failureReason} = result
    return {
        documentID: taskID,
        successCount: success ? 1 : 0,
        failCount: success ? 0: 1,
        status: success ? 'success' : 'failed',
        msg: failureReason
    }
}

export default {
    doConnect,
    getConnect,
    getAppInfo,
    getPrinters,
    print,
}



// WEBPACK FOOTER //
// ./src/utils/channelPrinter.js